import { render } from "./password.html?vue&type=template&id=3be1dafa&external"
import script from "./password.js?vue&type=script&lang=js&external"
export * from "./password.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__